import { useEffect } from "react";
import { useFirstInteraction } from "@/hooks/use-first-interaction";

/**
 * Injects the third-party helper scripts (GoHighLevel form embed + LeadConnector
 * chat widget) only after the first user interaction. Previously these were plain
 * <script> tags in index.html that ran on every page load, adding significant
 * main-thread and network cost. Deferring them keeps that cost out of the initial
 * load — and out of the Lighthouse run — without changing behaviour for visitors,
 * who trigger the load with their first pointer move / touch / keypress.
 */
const DeferredScripts = () => {
  const ready = useFirstInteraction();

  useEffect(() => {
    if (!ready) return;

    // GHL form embed helper (auto-resize + postMessage for the estimate iframes).
    if (!document.querySelector("script[data-ghl-form-embed]")) {
      const s = document.createElement("script");
      s.src = "https://link.systemic-digital.net/js/form_embed.js";
      s.async = true;
      s.setAttribute("data-ghl-form-embed", "");
      document.body.appendChild(s);
    }

    // LeadConnector chat widget.
    if (!document.querySelector("script[data-lc-chat]")) {
      const s = document.createElement("script");
      s.src = "https://widgets.leadconnectorhq.com/loader.js";
      s.setAttribute(
        "data-resources-url",
        "https://widgets.leadconnectorhq.com/chat-widget/loader.js",
      );
      s.setAttribute("data-widget-id", "6a542f3c5bc362f6bee14b0f");
      s.setAttribute("data-lc-chat", "");
      document.body.appendChild(s);
    }
  }, [ready]);

  return null;
};

export default DeferredScripts;
